import { useCallback } from 'react';

import { Paragraph } from '@/components/Paragraph';
import { useScrollSpy } from '@/hooks/useScrollSpy';

import { StyledDayTagMenu, StyledDayIndicator } from './styles';

import type { ItineraryBlock } from '@/types/itinerary';

interface DayIndicatorProps {
  itineraryBlocks: ItineraryBlock[];
  sticky?: boolean;
}

export function DayIndicator({ itineraryBlocks, sticky = false }: DayIndicatorProps) {
  const { currentSectionId } = useScrollSpy({
    sections:
      itineraryBlocks?.map((block) => ({
        id: block.id,
        elementId: `program-section-${block.id}`,
      })) || [],
  });

  const scrollToProgramSection = useCallback((programId: string) => {
    document.getElementById(`program-section-${programId}`)?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <StyledDayIndicator $sticky={sticky}>
      {itineraryBlocks?.map((block) => (
        <StyledDayTagMenu
          $isActive={currentSectionId === block.id}
          key={block.id}
          onClick={() => {
            scrollToProgramSection(block.id);
          }}
        >
          <Paragraph
            color={currentSectionId === block.id ? 'white' : 'bodyTextColor'}
            weight={600}
          >{`Day ${block.startDay} t/m ${Number(block.startDay) + Number(block.duration)}`}</Paragraph>
        </StyledDayTagMenu>
      ))}
    </StyledDayIndicator>
  );
}
